import { render } from "./ClassroomProgramm.vue?vue&type=template&id=211d4507"
import script from "./ClassroomProgramm.vue?vue&type=script&lang=js"
export * from "./ClassroomProgramm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__